import React from 'react';
import { 
  EyeIcon, 
  ChatBubbleLeftIcon 
} from '@heroicons/react/24/outline';
import LikeButton from './LikeButton';

/**
 * Mobile-optimized action bar for forum posts
 * Displays view count, reply count, and like actions with icons
 */
const MobilePostActions = ({
  viewCount = 0,
  replyCount = 0,
  likeCount = 0,
  isLiked = false,
  targetId,
  targetType = 'question',
  authorId,
  onLike,
  onReply,
  size = 'md'
}) => {
  const sizeConfig = {
    sm: {
      icon: 'w-4 h-4',
      text: 'text-xs',
      spacing: 'space-x-4',
      padding: 'py-2'
    },
    md: {
      icon: 'w-5 h-5',
      text: 'text-sm',
      spacing: 'space-x-6',
      padding: 'py-3'
    }
  };

  const config = sizeConfig[size] || sizeConfig.md;

  return (
    <div className={`flex items-center justify-between ${config.padding} border-t border-gray-100 dark:border-gray-700`}>
      {/* Left side - Engagement metrics */}
      <div className={`flex items-center ${config.spacing} ${config.text} text-gray-500 dark:text-gray-400`}>
        {/* View count */}
        <div className="flex items-center space-x-1">
          <EyeIcon className={config.icon} />
          <span className="font-medium">{viewCount}</span>
        </div>

        {/* Reply count */}
        <button
          onClick={onReply}
          className={`flex items-center space-x-1 hover:text-purple-600 dark:hover:text-purple-400 transition-colors duration-200 min-h-[44px] min-w-[44px] px-3 py-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 active:scale-95 active:bg-gray-100 dark:active:bg-gray-700`}
          style={{ touchAction: 'manipulation' }}
        >
          <ChatBubbleLeftIcon className={config.icon} />
          <span className="font-medium">{replyCount}</span>
        </button>
      </div>

      {/* Right side - Like button */}
      <div>
        <LikeButton
          targetType={targetType}
          targetId={targetId}
          initialLikeCount={likeCount}
          authorId={authorId}
          onLikeUpdate={onLike}
          size={size === 'sm' ? 'sm' : 'md'}
          showCount={true}
          className="border-none bg-transparent hover:bg-gray-50 dark:hover:bg-gray-800"
        />
      </div>
    </div>
  );
};

export default MobilePostActions;